import { Fragment } from "react";

const DescriptionList = ({ data }) => {
  return (
    <dl>
      {data.map(({ term, description }) => (
        <Fragment key={`description-item-${term}`}>
          <dt>{term}</dt>
          <dd style={{ whiteSpace: "pre-wrap" }}>{description}</dd>
        </Fragment>
      ))}
    </dl>
  );
};

export default DescriptionList;
